var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12293 2.84904C2.60113 2.84904 2.98878 2.46139 2.98878 1.98319C2.98878 1.50499 2.60113 1.11734 2.12293 1.11734C1.64473 1.11734 1.25708 1.50499 1.25708 1.98319C1.25708 2.46139 1.64473 2.84904 2.12293 2.84904Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.84715,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12293 9.19868C2.60113 9.19868 2.98878 8.81102 2.98878 8.33283C2.98878 7.85463 2.60113 7.46697 2.12293 7.46697C1.64473 7.46697 1.25708 7.85463 1.25708 8.33283C1.25708 8.81102 1.64473 9.19868 2.12293 9.19868Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.84715,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12293 15.5483C2.60113 15.5483 2.98878 15.1606 2.98878 14.6824C2.98878 14.2042 2.60113 13.8165 2.12293 13.8165C1.64473 13.8165 1.25708 14.2042 1.25708 14.6824C1.25708 15.1606 1.64473 15.5483 2.12293 15.5483Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.84715,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.6d62319c6c0054df76af72d18e20cc9c.svg";
export { ForwardRef as ReactComponent };